import React, { useEffect, useState } from 'react';
import styles from '../../styles/home/EmbeddedYTVideo.module.scss';

// interface EmbeddedYTVideoProps {
//     videoId: string;
//     width?: number;
//     height?: number;
//     title?: string;
// }

const EmbeddedYTVideo = ({
  videoId,
  width = 560,
  height = 315,
  title = 'Video',
  autoplay = 1,
  mute = 1,
}) => {
  const [videoUrl, setVideoUrl] = useState('');

  useEffect(() => {
    setVideoUrl(`https://www.youtube.com/embed/${videoId}?autoplay=${autoplay}&mute=${mute}&loop=1&playlist=${videoId}&vq=hd1080`);
  }, [videoId, autoplay, mute]);

  return (
   <div className={styles.wrapper}>
     <div className={styles.videoContainer}>
      <iframe
        loading="lazy"
        width={width}
        height={height}
        src={videoUrl}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture full"
        allowFullScreen
      />
    </div>
   </div>
  );
};

export default EmbeddedYTVideo;
